import React, { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { AddIcon, Button } from "native-base";

export default function CreateBranchButton() {
  const navigate = useNavigate();

  const onCreateObject = useCallback(async () => {
    navigate(`/admin/branches/create`);
  }, [navigate]);

  return (
    <Button
      onPress={onCreateObject}
      colorScheme="primary"
      startIcon={<AddIcon />}
      alignSelf="flex-end"
    >
      Niederlassung erstellen
    </Button>
  );
}
